import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs';
import { ConfirmDialogComponent } from '../features/technique-detail/components/technique-detail/confirm-dialog.component';

export interface CanComponentDeactivate {
  canDeactivate(): boolean;
}

/**
 * F5: confirms with the user before navigating away from unsaved notes.
 * Covers all internal navigation (router links, back button) that the
 * prev/next confirm-discard didn't catch. `beforeunload` still handles
 * tab close / external navigation.
 */
export const unsavedNotesGuard: CanDeactivateFn<CanComponentDeactivate> = (component) => {
  if (!component || component.canDeactivate()) {
    return true;
  }

  const dialog = inject(MatDialog);
  return dialog
    .open(ConfirmDialogComponent, {
      data: {
        title: 'Modifiche non salvate',
        message: 'Hai modifiche non salvate. Vuoi davvero uscire?',
        actions: [
          { label: 'Esci senza salvare', primary: false, action: 'discard' },
          { label: 'Resta', primary: true, action: 'stay' },
        ],
      },
      width: '400px',
    })
    .afterClosed()
    .pipe(map((result) => result === 'discard'));
};
